import '../App.css';

import { Button, Card, Form } from 'react-bootstrap';
import React, { useContext, useState } from 'react';

import ComplaintPage from './ComplaintPage';
import { CustomerDetailPage } from './CustomerDetailPage'
import { MainContext } from '../App';
import apiService from '../api';

export const LoginPageWithUserDetail = (props) => {
    const { accessToken, setAccessToken, setProgress, setErrorMessage, reactGa } = useContext(MainContext);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { email, password } = formData;
        reactGa.event({
            category: "login",
            action: "login",
            label: email,
            nonInteraction: false, // optional, true/false
        });
        apiService.update({email, password}, 'login', null, setProgress, setErrorMessage)
          .then(data => {
              if (data.accessToken === undefined)
                  return;
            setAccessToken(data.accessToken);
            localStorage.setItem('kentist-musteri-accessToken', data.accessToken);
            if (data.sasToken) {
              localStorage.setItem('sasToken', data.sasToken);
            }
          });
    };

    if (window.location.pathname === '/sikayet') {
        return <ComplaintPage />;
    };
    
    if (accessToken) {
        return <CustomerDetailPage />;
    } else {
        return (
          <div className="login-container" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%', overflow: 'hidden', gap: '30px' }}>
            <div className="text-center" style={{
                  background: 'white',
                  padding: '8px 20px',
                  borderRadius: '30px',
                  display: 'inline-flex',
                  alignItems: 'center'
                }}>
              <img
                src={`${process.env.PUBLIC_URL}/kentistlogo.png`}
                alt="Kentist Turizm"
                style={{ width: '250px' }}
              />
            </div>
      <Card style={{ borderRadius: '20px', width: '100%', maxWidth: '500px', minHeight: '400px', boxShadow: '0 8px 40px 0 rgba(20, 52, 92, 0.4), 0 0 0 1px rgba(20, 52, 92, 0.3)', display: 'flex', background: 'linear-gradient(135deg, rgba(20, 20, 20, 0.95) 0%, rgba(40, 40, 40, 0.95) 100%)', backdropFilter: 'blur(20px)', border: '2px solid rgba(20, 52, 92, 0.5)', padding: '20px 40px 40px 40px' }}>
            <Card.Body style={{ padding: 0 }}>
              <h2 className="text-center my-4" style={{ color: '#5a9bd4', textShadow: '0 0 20px rgba(20, 52, 92, 0.6)', fontWeight: '700', letterSpacing: '1px', marginBottom: '30px' }}>Kurumsal Müşteri Girişi</h2>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="email">
                  <Form.Label style={{ color: '#5a9bd4', fontWeight: '500' }}>E-posta:</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(20, 52, 92, 0.5)', color: 'white' }}
                  />
                </Form.Group>
                <Form.Group controlId="password" style={{ marginTop: 10 }}>
                  <Form.Label style={{ color: '#5a9bd4', fontWeight: '500' }}>Şifre:</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    required
                    style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(20, 52, 92, 0.5)', color: 'white' }}
                  />
                </Form.Group>
                <Button style={{ width: '100%', marginTop: 20, background: 'linear-gradient(135deg, #14345c 0%, #1e5a8a 100%)', border: 'none', color: '#fff', fontWeight: '700', padding: '12px 30px', boxShadow: '0 4px 15px rgba(20, 52, 92, 0.5)', transition: 'all 0.3s ease' }} type="submit">
                  Giriş Yap
                </Button>
              </Form>
            </Card.Body>
      </Card>
            <div className="text-center" style={{ marginTop: '20px' }}>
              <img
                src={`${process.env.PUBLIC_URL}/tulparfooterinverted.png`}
                alt="Tulpar"
                style={{ maxWidth: '150px', width: '100%', opacity: 0.7, filter: 'drop-shadow(0 0 10px rgba(20, 52, 92, 0.3))' }}
              />
            </div>
    </div>)
    }
}